import { Injectable } from "@angular/core";
import { Sidebar } from "primeng/sidebar";

@Injectable()
export class SideBarOverrideService {
}

const origionalFunc = Sidebar.prototype.destroyModal;
Sidebar.prototype.destroyModal = function destroyIfHasModal() {
    if (this.modal) {
        (origionalFunc.bind(this))();
    }
}
